import { PROFILE_TYPE } from 'domain/value-objects/profile-type';
import { useAuth } from 'presentation/app/hooks/useAuth';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Col, Collapse, Row } from 'reactstrap';

import withRouter from '../../partials/Common/withRouter';

const HorizontalLayout = (props: any) => {
  const { auth, currentUser } = useAuth();
  const [openMenus, setOpenMenus] = useState<Set<string>>(new Set());
  const menuItems = [];
  const splitMenuItems: Array<any> = [];

  const closeMobileMenu = () => {
    const windowSize = document.documentElement.clientWidth;
    if (windowSize <= 1024) {
      document.body.classList.remove('menu');
    }
  };

  const toggleMenu = (menuId: string) => {
    setOpenMenus((prev) => {
      if (prev.has(menuId)) {
        const newSet = new Set(prev);
        newSet.delete(menuId);
        return newSet;
      }

      return new Set([menuId]);
    });
  };

  menuItems.push(
    {
      id: 1,
      label: 'Dashboard',
      icon: 'ri-dashboard-line',
      link: '/#',
      stateVariables: openMenus.has('1'),
      click: function (e: any) {
        e.preventDefault();
        toggleMenu('1');
        closeMobileMenu();
      },
    },
    {
      id: 2,
      label: 'Organizações',
      icon: 'ri-organization-chart',
      link: '/organizacoes',
      stateVariables: openMenus.has('2'),
      click: function (e: any) {
        e.preventDefault();
        toggleMenu('2');
        closeMobileMenu();
      },
    },
    {
      id: 10,
      label: 'Pessoas',
      icon: 'ri-user-3-line',
      link: '/pessoas',
      stateVariables: openMenus.has('10'),
      click: function (e: any) {
        e.preventDefault();
        toggleMenu('10');
        closeMobileMenu();
      },
    },

    {
      id: 4,
      label: 'Cadastros',
      icon: 'ri-group-line',
      link: '/#',
      stateVariables: openMenus.has('4'),
      subItems: [
        {
          id: 5,
          label: 'Cursos',
          icon: 'ri-book-line',
          link: '/cadastros/cursos',
          stateVariables: openMenus.has('5'),
          click: function (e: any) {
            e.preventDefault();
            toggleMenu('5');
            closeMobileMenu();
          },
        },
        {
          id: 6,
          label: 'Setores',
          icon: 'ri-building-line',
          link: '/cadastros/setores',
          stateVariables: openMenus.has('6'),
          click: function (e: any) {
            e.preventDefault();
            toggleMenu('6');
            closeMobileMenu();
          },
        },
        {
          id: 7,
          label: 'Locais de estágio',
          icon: 'ri-map-pin-user-line',
          link: '/cadastros/locais-de-estagio',
          stateVariables: openMenus.has('7'),
          click: function (e: any) {
            e.preventDefault();
            toggleMenu('7');
            closeMobileMenu();
          },
        },
        {
          id: 8,
          label: 'Tarefas',
          icon: 'ri-file-list-line',
          link: '/cadastros/tarefas',
          stateVariables: openMenus.has('8'),
          click: function (e: any) {
            e.preventDefault();
            toggleMenu('8');
            closeMobileMenu();
          },
        },
        {
          id: 9,
          label: 'Instrumentos de Avaliação',
          icon: 'ri-user-star-line',
          link: '/cadastros/instrumentos-de-avaliacao',
          stateVariables: openMenus.has('9'),
          click: function (e: any) {
            e.preventDefault();
            toggleMenu('9');
            closeMobileMenu();
          },
        },
        {
          id: 10,
          label: 'Parceiros',
          icon: 'ri-shake-hands-line',
          link: '/cadastros/parceiros',
          stateVariables: openMenus.has('10'),
          click: function (e: any) {
            e.preventDefault();
            toggleMenu('10');
            closeMobileMenu();
          },
        },
        ...(auth?.activeProfile?.profileId === PROFILE_TYPE.ADMINISTRATOR ||
        currentUser?.activeProfile?.profileId === PROFILE_TYPE.ADMINISTRATOR
          ? [
              {
                id: 3,
                label: 'Usuários',
                icon: 'ri-user-3-line',
                link: '/cadastros/usuarios',
                stateVariables: openMenus.has('3'),
                click: function (e: any) {
                  e.preventDefault();
                  toggleMenu('3');
                  closeMobileMenu();
                },
              },
            ]
          : []),
      ],
      click: function (e: any) {
        e.preventDefault();
        toggleMenu('4');
      },
      isMoreMenu: true,
    },
    {
      id: 9,
      label: 'Relatórios',
      icon: 'ri-file-line',
      link: '/#',
      stateVariables: openMenus.has('9'),
      subItems: [
        {
          id: 10,
          label: 'Radinos',
          icon: 'ri-user-star-line',
          link: '/relatorios/radinos',
          stateVariables: openMenus.has('10'),
          click: function (e: any) {
            e.preventDefault();
            toggleMenu('10');
            closeMobileMenu();
          },
        },
      ],
      click: function (e: any) {
        e.preventDefault();
        toggleMenu('9');
      },
    },
    {
      id: 9,
      label: 'Ferramentas',
      icon: 'ri-tools-fill',
      link: '/#',
      stateVariables: openMenus.has('9'),
      subItems: [
        {
          id: 10,
          label: 'Push notification',
          icon: 'ri-user-star-line',
          link: '/ferramentas/push-notification',
          stateVariables: openMenus.has('10'),
          click: function (e: any) {
            e.preventDefault();
            toggleMenu('10');
            closeMobileMenu();
          },
        },
        {
          id: 11,
          label: 'WhatsApp',
          icon: 'ri-user-star-line',
          link: '/#',
          stateVariables: openMenus.has('11'),
          click: function (e: any) {
            e.preventDefault();
            toggleMenu('11');
            closeMobileMenu();
          },
        },
        /* {
          id: 12,
          label: 'Notificações',
          icon: 'ri-calendar-check-line',
          link: '/ferramentas/notificacoes',
          stateVariables: openMenus.has('12'),
          click: function (e: any) {
            e.preventDefault();
            toggleMenu('12');
            closeMobileMenu();
          },
        }, */
        ...(auth?.activeProfile?.profileId === PROFILE_TYPE.ADMINISTRATOR ||
        currentUser?.activeProfile?.profileId === PROFILE_TYPE.ADMINISTRATOR
          ? [
              {
                id: 13,
                label: 'Chaves de API',
                icon: 'ri-key-2-line',
                link: '/ferramentas/chaves-api',
                stateVariables: openMenus.has('13'),
                click: function (e: any) {
                  e.preventDefault();
                  toggleMenu('13');
                  closeMobileMenu();
                },
              },
            ]
          : []),
      ],
      click: function (e: any) {
        e.preventDefault();
        toggleMenu('9');
      },
    },
  );

  const path = props.router.location.pathname;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    const initMenu = () => {
      const pathName = process.env.PUBLIC_URL + path;
      const ul = document.getElementById('navbar-nav') as HTMLElement;
      const items: any = ul.getElementsByTagName('a');
      const itemsArray = [...items]; // converts NodeList to Array
      removeActivation(itemsArray);
      const matchingMenuItem = itemsArray.find((x) => {
        return x.pathname === pathName;
      });
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem);
      }
    };
    initMenu();
  }, [path, props.layoutType]);

  function activateParentDropdown(item: any) {
    item.classList.add('active');
    const parentCollapseDiv = item.closest('.collapse.menu-dropdown');

    if (parentCollapseDiv) {
      // to set aria expand true remaining
      parentCollapseDiv.classList.add('show');
      parentCollapseDiv.parentElement.children[0].classList.add('active');
      parentCollapseDiv.parentElement.children[0].setAttribute(
        'aria-expanded',
        'true',
      );
      if (parentCollapseDiv.parentElement.closest('.collapse.menu-dropdown')) {
        parentCollapseDiv.parentElement
          .closest('.collapse')
          .classList.add('show');
        const parentElementDiv =
          parentCollapseDiv.parentElement.closest(
            '.collapse',
          ).previousElementSibling;
        if (parentElementDiv)
          if (parentElementDiv.closest('.collapse'))
            parentElementDiv.closest('.collapse').classList.add('show');
        parentElementDiv.classList.add('active');
        const parentElementSibling =
          parentElementDiv.parentElement.parentElement.parentElement
            .previousElementSibling;
        if (parentElementSibling) {
          parentElementSibling.classList.add('active');
        }
      }
      return false;
    }
    return false;
  }

  const removeActivation = (items: any) => {
    const actiItems = items.filter((x: any) => x.classList.contains('active'));

    actiItems.forEach((item: any) => {
      if (item.classList.contains('menu-link')) {
        if (!item.classList.contains('active')) {
          item.setAttribute('aria-expanded', false);
        }
        if (item.nextElementSibling) {
          item.nextElementSibling.classList.remove('show');
        }
      }
      if (item.classList.contains('nav-link')) {
        if (item.nextElementSibling) {
          item.nextElementSibling.classList.remove('show');
        }
        item.setAttribute('aria-expanded', false);
      }
      item.classList.remove('active');
    });
  };

  return (
    <React.Fragment>
      {(menuItems || []).map((item: any, key: number) => {
        return (
          <React.Fragment key={key}>
            {/* Main Header */}
            {!item['isHeader'] ? (
              item.subItems ? (
                <li className="nav-item">
                  <Link
                    onClick={item.click}
                    className="nav-link menu-link"
                    to={item.link ? item.link : '/#'}
                    data-bs-toggle="collapse"
                  >
                    <i className={item.icon}></i>{' '}
                    <span data-key="t-apps">{props.t(item.label)}</span>
                  </Link>
                  <Collapse
                    className={
                      item.id === 'baseUi' && item.subItems.length > 13
                        ? 'menu-dropdown mega-dropdown-menu'
                        : 'menu-dropdown'
                    }
                    isOpen={item.stateVariables}
                    id="sidebarApps"
                  >
                    {/* subItms  */}
                    {item.id === 'baseUi' && item.subItems.length > 13 ? (
                      <React.Fragment>
                        <Row>
                          {item.subItems &&
                            (item.subItems || []).map(
                              (subItem: any, key: number) => (
                                <React.Fragment key={key}>
                                  {key % 2 === 0 ? (
                                    <Col lg={4}>
                                      <ul className="nav nav-sm flex-column">
                                        <li className="nav-item">
                                          <Link
                                            to={item.subItems[key].link}
                                            className="nav-link"
                                          >
                                            {item.subItems[key].label}
                                          </Link>
                                        </li>
                                      </ul>
                                    </Col>
                                  ) : (
                                    <Col lg={4}>
                                      <ul className="nav nav-sm flex-column">
                                        <li className="nav-item">
                                          <Link
                                            to={item.subItems[key].link}
                                            className="nav-link"
                                          >
                                            {item.subItems[key].label}
                                          </Link>
                                        </li>
                                      </ul>
                                    </Col>
                                  )}
                                </React.Fragment>
                              ),
                            )}
                        </Row>
                      </React.Fragment>
                    ) : (
                      <ul className="nav nav-sm flex-column test">
                        {item.subItems &&
                          (item.subItems || []).map(
                            (subItem: any, key: number) => (
                              <React.Fragment key={key}>
                                {!subItem.isChildItem ? (
                                  <li className="nav-item">
                                    <Link
                                      to={subItem.link ? subItem.link : '/#'}
                                      className="nav-link"
                                      onClick={closeMobileMenu}
                                    >
                                      {props.t(subItem.label)}
                                    </Link>
                                  </li>
                                ) : (
                                  <li className="nav-item">
                                    <Link
                                      onClick={subItem.click}
                                      className="nav-link"
                                      to="/#"
                                      data-bs-toggle="collapse"
                                    >
                                      {' '}
                                      {props.t(subItem.label)}
                                    </Link>
                                    <Collapse
                                      className="menu-dropdown"
                                      isOpen={subItem.stateVariables}
                                      id="sidebarEcommerce"
                                    >
                                      <ul className="nav nav-sm flex-column">
                                        {/* child subItms  */}
                                        {subItem.childItems &&
                                          (subItem.childItems || []).map(
                                            (
                                              subChildItem: any,
                                              key: number,
                                            ) => (
                                              <React.Fragment key={key}>
                                                {!subChildItem.isChildItem ? (
                                                  <li className="nav-item">
                                                    <Link
                                                      to={
                                                        subChildItem.link
                                                          ? subChildItem.link
                                                          : '/#'
                                                      }
                                                      className="nav-link"
                                                      onClick={closeMobileMenu}
                                                    >
                                                      {props.t(
                                                        subChildItem.label,
                                                      )}
                                                    </Link>
                                                  </li>
                                                ) : (
                                                  <li className="nav-item">
                                                    <Link
                                                      onClick={
                                                        subChildItem.click
                                                      }
                                                      className="nav-link"
                                                      to="/#"
                                                      data-bs-toggle="collapse"
                                                    >
                                                      {' '}
                                                      {props.t(
                                                        subChildItem.label,
                                                      )}
                                                    </Link>
                                                    <Collapse
                                                      className="menu-dropdown"
                                                      isOpen={
                                                        subChildItem.stateVariables
                                                      }
                                                      id="sidebarEcommerce"
                                                    >
                                                      <ul className="nav nav-sm flex-column">
                                                        {/* child subItms  */}
                                                        {subChildItem.childItems &&
                                                          (
                                                            subChildItem.childItems ||
                                                            []
                                                          ).map(
                                                            (
                                                              subSubChildItem: any,
                                                              key: number,
                                                            ) => (
                                                              <li
                                                                className="nav-item apex"
                                                                key={key}
                                                              >
                                                                <Link
                                                                  to={
                                                                    subSubChildItem.link
                                                                      ? subSubChildItem.link
                                                                      : '/#'
                                                                  }
                                                                  className="nav-link"
                                                                  onClick={
                                                                    closeMobileMenu
                                                                  }
                                                                >
                                                                  {props.t(
                                                                    subSubChildItem.label,
                                                                  )}
                                                                </Link>
                                                              </li>
                                                            ),
                                                          )}
                                                      </ul>
                                                    </Collapse>
                                                  </li>
                                                )}
                                              </React.Fragment>
                                            ),
                                          )}
                                      </ul>
                                    </Collapse>
                                  </li>
                                )}
                              </React.Fragment>
                            ),
                          )}
                      </ul>
                    )}
                  </Collapse>
                </li>
              ) : (
                <li className="nav-item">
                  <Link
                    className="nav-link menu-link"
                    to={item.link ? item.link : '/#'}
                    onClick={closeMobileMenu}
                  >
                    <i className={item.icon}></i>{' '}
                    <span>{props.t(item.label)}</span>
                  </Link>
                </li>
              )
            ) : (
              <li className="menu-title">
                <span data-key="t-menu">{props.t(item.label)}</span>
              </li>
            )}
          </React.Fragment>
        );
      })}
      {/* menu Items */}
    </React.Fragment>
  );
};

HorizontalLayout.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(HorizontalLayout));
